// Module-level flag: true while a user is in "session expired, but kept on the
// page" grace mode (see AuthSessionProvider). Read by handleTokenExpiration so a
// background 401 doesn't pop the "refresh the page" modal — which would reload
// away the very work the grace mode exists to preserve.
//
// Deliberately a plain module variable, not React state: the consumer
// (serviceErrorUtil.handleTokenExpiration) is a non-React error handler, and a
// simple getter/setter avoids a circular provider dependency.
let graceActive = false;

export const setSessionGraceActive = (active: boolean): void => {
  graceActive = active;
};

export const isSessionGraceActive = (): boolean => graceActive;
